import axios from 'axios';
import baseService from '../shared/baseService';

const clientService = () => baseService('clients');

const clientByUserService = (userId: number) => baseService(`clients/users/${userId}`);
const clientGetAll = (inactive: boolean) => axios.get(`clients?includeInactive=${inactive}`);

const createClient = (params: FormData) => axios.post('clients', params, {headers: {'Content-Type': 'multipart/form-data'}} );
const updateClient = (clientId: number, params: FormData) => axios.post(`clients/${clientId}`, params, {headers: {'Content-Type': 'multipart/form-data'}} );

export default {
    clientService,
    clientByUserService,
    clientGetAll,
    createClient,
    updateClient
};

